import { render, staticRenderFns } from "./BaseIconTitle.vue?vue&type=template&id=1c388538&scoped=true"
import script from "./BaseIconTitle.vue?vue&type=script&lang=js"
export * from "./BaseIconTitle.vue?vue&type=script&lang=js"
import style0 from "./BaseIconTitle.vue?vue&type=style&index=0&id=1c388538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c388538",
  null
  
)

export default component.exports